<panel>
	<h1>Custom Input</h1>
	<section scrollable>
		<section>
			<text-group>
				<custom-input label="Text"
							  placeholder="placeholder"
							  [inputType]="inputTypeEnum.Text"
							  [(value)]="textValueValidation"
							  hint="Indtast mere end 5"
							  [customValidState]="textValueValidation.length > 5"
							  [customValidationMessage]="'validation.text.length.gt' | translate: { 'value': 5 }" />
				{{ textValueValidation }}
			</text-group>
			<custom-input label="HTML Editor" placeholder="placeholder" [inputType]="inputTypeEnum.Editor" [(value)]="textValue" />
			<text-group>
				<custom-input label="Text" placeholder="placeholder" [inputType]="inputTypeEnum.Text" [(value)]="textValue" />
				{{ textValue }}
			</text-group>
			<text-group>
				<custom-input label="Textarea" placeholder="placeholder" [inputType]="inputTypeEnum.Textarea" [(value)]="textareaValue" />
				{{ textareaValue }}
			</text-group>
			<text-group>
				<custom-input label="Number" placeholder="placeholder" [inputType]="inputTypeEnum.Number" [(value)]="numberValue" />
				{{ numberValue }}
			</text-group>
			<text-group>
				<custom-input label="Currency" placeholder="placeholder" [inputType]="inputTypeEnum.Currency" [(value)]="currencyValue" />
				{{ currencyValue }}
			</text-group>
			<text-group>
				<custom-input label="Percentage" placeholder="placeholder" [inputType]="inputTypeEnum.Percentage" [(value)]="percentageValue" />
				{{ percentageValue }}
			</text-group>
			<text-group>
				<custom-input label="Switch" placeholder="placeholder" [inputType]="inputTypeEnum.Switch" [(value)]="switchValue" />
				{{ switchValue }}
			</text-group>
			<text-group>
				<custom-input label="Email" placeholder="placeholder" [inputType]="inputTypeEnum.Text" [(value)]="emailValue" [validation]="validationType.Email" />
				{{ emailValue }}
			</text-group>
			<text-group>
				<date-input label="Date" placeholder="placeholder" [(value)]="dateValue" [minDate]="today" [required]="true" />
				{{ dateValue }}
			</text-group>
			<text-group>
				<custom-input [vertical]="true" label="Select one of these" inputType="radio" [(value)]="radioValue">
					<radio-button [value]="true" label="Of course!" />
					<radio-button [value]="false" label="Nah.." />
					<radio-button [value]="8" label="Eight" />
				</custom-input>
				{{ radioValue }}
			</text-group>

			<custom-input label="Suffix" placeholder="placeholder" suffix="suftext" />
			<custom-input label="Prefix" placeholder="placeholder" prefix="pretext" />
			<custom-input label="Suffix & Prefix" placeholder="placeholder" suffix="suftext" prefix="pretext" />

			<h2>Editable Content</h2>
			<editable-content *editableData="let edit from textareaValue" [editEnabled]="true">
				<display-content>
					{{ textareaValue }}
				</display-content>
				<edit-content>
					<custom-input label="Textarea" placeholder="placeholder" [inputType]="inputTypeEnum.Textarea" [(value)]="edit.value" />
				</edit-content>
			</editable-content>
		</section>
		<section>
			<button confirm
				#resetValuesButton
				(click)="resetCustomInputValues()"
				label="Reset values"
				[ignoreValidation]="true"
			></button>
		</section>
		<section>
			<custom-input label="Toggle icons for buttons" [inputType]="inputTypeEnum.Switch" [(value)]="showButtonIcons" />
			<custom-input label="Toggle selected for buttons" [inputType]="inputTypeEnum.Switch" [(value)]="selectButtons" />
			<custom-input label="Toggle disable for buttons" [inputType]="inputTypeEnum.Switch" [(value)]="disableButtons" />
			<custom-input label="Toggle validation for buttons" [inputType]="inputTypeEnum.Switch" [(value)]="checkValidation" />
		</section>
		<section>
			<button #confirmButton confirm label="test" (click)="confirmClick()" [active]="!disableButtons" [selected]="selectButtons" [ignoreValidation]="!checkValidation">@if (showButtonIcons) {
				<icon type="xmark" />
			}</button>
			<button #rejectButton reject label="test" (click)="rejectClick()" [active]="!disableButtons" [selected]="selectButtons" [ignoreValidation]="!checkValidation">@if (showButtonIcons) {
				<icon type="xmark" />
			} når label er sat</button>
			<button #neutralButton (click)="neutralClick()" [active]="!disableButtons" [selected]="selectButtons" [ignoreValidation]="!checkValidation">@if (showButtonIcons) {
				<icon type="xmark" />
			}Neutral knap wow!</button>
			<button #ghostButton ghost (click)="ghostClick()" [active]="!disableButtons" [selected]="selectButtons" [ignoreValidation]="!checkValidation">@if (showButtonIcons) {
				<icon type="xmark" />
			}du kan ikke se mig</button>
		</section>
		<section>
			<button #confirmButtonSmall small confirm label="test" (click)="confirmClick()" [active]="!disableButtons" [selected]="selectButtons" [ignoreValidation]="!checkValidation">@if (showButtonIcons) {
				<icon type="xmark" />
			}</button>
			<button #rejectButtonSmall small reject label="test" (click)="rejectClick()" [active]="!disableButtons" [selected]="selectButtons" [ignoreValidation]="!checkValidation">@if (showButtonIcons) {
				<icon type="xmark" />
			} når label er sat</button>
			<button #neutralButtonSmall small (click)="neutralClick()" [active]="!disableButtons" [selected]="selectButtons" [ignoreValidation]="!checkValidation">@if (showButtonIcons) {
				<icon type="xmark" />
			}Neutral knap wow!</button>
			<button #ghostButtonSmall small ghost (click)="ghostClick()" [active]="!disableButtons" [selected]="selectButtons" [ignoreValidation]="!checkValidation">@if (showButtonIcons) {
				<icon type="xmark" />
			}du kan ikke se mig</button>
		</section>
		<section>
			<button add confirm label="test" (click)="confirmClick()" [active]="!disableButtons" [selected]="selectButtons" [ignoreValidation]="!checkValidation">@if (showButtonIcons) {
				<icon type="xmark" />
			}</button>
			<button add reject label="test" (click)="rejectClick()" [active]="!disableButtons" [selected]="selectButtons" [ignoreValidation]="!checkValidation">@if (showButtonIcons) {
				<icon type="xmark" />
			} når label er sat</button>
			<button add (click)="neutralClick()" [active]="!disableButtons" [selected]="selectButtons" [ignoreValidation]="!checkValidation">@if (showButtonIcons) {
				<icon type="xmark" />
			}Neutral knap wow!</button>
			<button add ghost (click)="ghostClick()" [active]="!disableButtons" [selected]="selectButtons" [ignoreValidation]="!checkValidation">@if (showButtonIcons) {
				<icon type="xmark" />
			}du kan ikke se mig</button>
		</section>
		<section>
			<button add small confirm label="test" (click)="confirmClick()" [active]="!disableButtons" [selected]="selectButtons" [ignoreValidation]="!checkValidation">@if (showButtonIcons) {
				<icon type="xmark" />
			}</button>
			<button add small reject label="test" (click)="rejectClick()" [active]="!disableButtons" [selected]="selectButtons" [ignoreValidation]="!checkValidation">@if (showButtonIcons) {
				<icon type="xmark" />
			} når label er sat</button>
			<button add small (click)="neutralClick()" [active]="!disableButtons" [selected]="selectButtons" [ignoreValidation]="!checkValidation">@if (showButtonIcons) {
				<icon type="xmark" />
			}Neutral knap wow!</button>
			<button add small ghost (click)="ghostClick()" [active]="!disableButtons" [selected]="selectButtons" [ignoreValidation]="!checkValidation">@if (showButtonIcons) {
				<icon type="xmark" />
			}du kan ikke se mig</button>
		</section>
	</section>
</panel>

<panel>
	<h1>Custom Select</h1>
	<section scrollable>
		<data-table>
			<data-row columns="8"><label>Input field</label></data-row><data-row columns="4"><label>Value</label></data-row>
			<data-row columns="8">
				<custom-select label="Short selectlist"
					placeholder="placeholder"
					[selectList]="selectListShort"
					[(value)]="selectListShortValue"
				[required]="false"></custom-select>
			</data-row>
			<data-row columns="4">{{ selectListShortValue }}</data-row>
			<data-row columns="12">
				<a (click)="enlarge = true">Enlarge contents ;-)</a>
				<div style="height: 2000px; width: 10px;" [hidden]="!enlarge"></div>
			</data-row>
			<data-row columns="8">
				<custom-select label="Short selectlist"
					placeholder="placeholder"
					[selectList]="selectListLong"
					[(value)]="selectListLongValue"
				[required]="true"></custom-select>
			</data-row>
			<data-row columns="4">{{ selectListLongValue }}</data-row>
			<data-row columns="12">
				<div style="height: 2000px; width: 10px;" [hidden]="!enlarge"></div>
			</data-row>
		</data-table>
	</section>
	<section>
		<button confirm #pushNewValuesToSelectListsButton (click)="pushNewValuesToSelectLists()" label="Push new values to select lists" [ignoreValidation]="true"></button>
		<button confirm #changeSelectListsButton (click)="changeSelectLists()" label="Change select lists" [ignoreValidation]="true"></button>
	</section>
</panel>

<panel>
	<h1>Add multiple</h1>
	<section scrollable>
		<h2>Settings</h2>
		<custom-input label="Listen on itemAdded" [inputType]="inputTypeEnum.Switch" [(value)]="listenToItemAdded" />
		<custom-input label="Listen on selectItemsChange" [inputType]="inputTypeEnum.Switch" [(value)]="listenToSelectedItemsChange" />
		<data-table>
			<data-row columns="6"><custom-select label="Validation Type" [selectList]="validationTypeSelectList" [(value)]="selectedValidationTypeString" hint="Only Domain and Email is implemented" /></data-row>
		</data-table>
		<data-table>
			<data-row columns="8"><label>Input field</label></data-row><data-row columns="4"><label>Value</label></data-row>
			<data-row columns="8">
				<add-multiple label="Normal"
					placeholder="placeholder"
					[(selectedItems)]="itemsSelected0"
					[availableItems]="itemsOptions0"
					[emitNewValues]="false"
					(itemAdded)="listenToItemAdded && reactToEvent($event, 'Emit new values - Item added')"
					(selectedItemsChange)="listenToSelectedItemsChange && reactToEvent($event, 'selectItemsChange')"
					[validation]="selectedValidationType"
				[required]="addMultipleRequired"></add-multiple>
			</data-row>
			<data-row columns="4">{{ showValues(itemsSelected0) }}</data-row>

			<data-row columns="8">
				<add-multiple label="Emit new values"
					placeholder="placeholder"
					[(selectedItems)]="itemsSelected1"
					[availableItems]="itemsOptions1"
					[emitNewValues]="true"
					(itemAdded)="listenToItemAdded && reactToEvent($event, 'Emit new values - Item added')"
					(selectedItemsChange)="listenToSelectedItemsChange && reactToEvent($event, 'selectItemsChange')"
					[validation]="selectedValidationType"
				[required]="addMultipleRequired"></add-multiple>
			</data-row>
			<data-row columns="4">{{ showValues(itemsSelected1) }}</data-row>

			<data-row columns="12">
				<tags [(selectedTags)]="selectedTags" [tags]="tagOptions" />
			</data-row>
		</data-table>

		<list-view>
			<header>Number</header>
			<row *listData="let number from numbers">
				<column [sortValue]="number.value">{{ number.value }}</column>
			</row>
		</list-view>
	</section>
</panel>
